// Enum lý do giảm BCQT-03
export default {
  SubmitedStateBudget: 1,
  ToPayStateBudget: 2,
  CancelEstimate: 3,
};
